import { render, staticRenderFns } from "./MonthPickerGroup.vue?vue&type=template&id=481a63c6&"
import script from "./MonthPickerGroup.vue?vue&type=script&lang=js&"
export * from "./MonthPickerGroup.vue?vue&type=script&lang=js&"
import style0 from "./MonthPickerGroup.vue?vue&type=style&index=0&lang=less&scope=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports